import React, { useState, useEffect, useRef } from 'react'

import { Link, useHistory } from "react-router-dom";

import { getDocs, collection, serverTimestamp, addDoc } from "firebase/firestore";
import { firestore } from "../firebase/firebase";
import 'firebase/compat/firestore';

import {Avatar, Stepper, Step, Box, StepLabel, Button, Typography, StepContent, Paper, AppBar, Toolbar, IconButton, Accordion, AccordionSummary, AccordionDetails, Input } from "@mui/material";
import {  Card, Spinner, Row, Col, Form, Popover, OverlayTrigger, Offcanvas } from "react-bootstrap";

import france from "../images/france.svg"
import italy from "../images/italy.svg"
import spain from "../images/spain.svg"
import logo from "../images/logo.svg"

import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { Chart } from "react-google-charts";

import Footer from './footer/Footer';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();


const Levels = () => {

  const messagesRef = firestore.collection(`levels`);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState();

    const [days, setDays] = useState(1);

    
    const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    const level = localStorage.getItem("levelCount")

    const [success, setSuccess] = useState(null);

    const emailRef = useRef();

    const history = useHistory();





  
    const AlertDismissable = () => {
  
      if (success === true) {
        
        return (
          <div>
            <h6 style={{ color: 'green' }}>
              {`Signed up, thanks!`}
            </h6>
  
          </div>
            
            
        );
  
      } else if (success === false) {
  
        return (
            <h6 style={{color: 'red'}}>Opps, something went wrong!</h6>
        );
  
      } else {
  
        return null;
  
      };
    
    };
  
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
  
        const listRef = collection(firestore, `project watchlist`)
  
        await addDoc( listRef, {
          createdAt: serverTimestamp(),
          email: emailRef.current.value
          
        });
        
      } catch (error) {
  
        console.log(error.message);
        setSuccess(false);
        
      } finally {
  
        toast("Thanks for hanging around!")
        setSuccess(true);
  
      };
  
    };


    //Get the names of each of the levels

    const getUsers = async () => {
        const data = await getDocs(messagesRef);
        setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        setLoading(false);
      };
    
    
      //Gets the users and stops any loading...
      useEffect(() => {
    
        setLoading(true);
        getUsers();

        if(localStorage.getItem("language") === 'es-ES'){
          setImage(spain)
        } else if(localStorage.getItem("language") === 'it-IT'){
        setImage(italy)
        } else if(localStorage.getItem("language") === 'fr-FR'){
        setImage(france)
        };
        
      }, []);


  
    const [activeStep, setActiveStep] = useState(+level);
  
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
  
    const handleReset = () => {
      setActiveStep(0);
    };

    const pushLevel = (...params) => {
      localStorage.setItem('level', params[0])
      localStorage.setItem('selectedLevel', params[1])
    };

    const popover = (
      
      <Popover id={'popover-positioned-left'}>
        <Popover.Body>
          Hi there!
        </Popover.Body>
      </Popover>
    );



    const options = {
      chartArea: { width: "87%", height: "70%" },
      vAxis: { minValue: 0 },
    };

 

    const dayCount = (props) => {

      console.log(props)

      if((days - props) <= 0){
        return 0
      } else {
         return days - props;
      }

    };

    const data = [
      ["", 'Visits'],
      [new Date(Date.now() - 86400000 * 30), dayCount(30)],
      [new Date(Date.now() - 86400000 * 29), dayCount(29)],
      [new Date(Date.now() - 86400000 * 28), dayCount(28)],
      [new Date(Date.now() - 86400000 * 27), dayCount(27)],
      [new Date(Date.now() - 86400000 * 26), dayCount(26)],
      [new Date(Date.now() - 86400000 * 25), dayCount(25)],
      [new Date(Date.now() - 86400000 * 24), dayCount(24)],
      [new Date(Date.now() - 86400000 * 23), dayCount(23)],
      [new Date(Date.now() - 86400000 * 22), dayCount(22)],
      [new Date(Date.now() - 86400000 * 21), dayCount(21)],
      [new Date(Date.now() - 86400000 * 20), dayCount(20)],
      [new Date(Date.now() - 86400000 * 19), dayCount(19)],
      [new Date(Date.now() - 86400000 * 18), dayCount(18)],
      [new Date(Date.now() - 86400000 * 17), dayCount(17)],
      [new Date(Date.now() - 86400000 * 16), dayCount(16)],
      [new Date(Date.now() - 86400000 * 15), dayCount(15)],
      [new Date(Date.now() - 86400000 * 14), dayCount(14)],
      [new Date(Date.now() - 86400000 * 13), dayCount(13)],
      [new Date(Date.now() - 86400000 * 12), dayCount(12)],
      [new Date(Date.now() - 86400000 * 11), dayCount(11)],
      [new Date(Date.now() - 86400000 * 10), dayCount(10)],
      [new Date(Date.now() - 86400000 * 9), dayCount(9)],
      [new Date(Date.now() - 86400000 * 8), dayCount(8)],
      [new Date(Date.now() - 86400000 * 7), dayCount(7)],
      [new Date(Date.now() - 86400000 * 6), dayCount(6)],
      [new Date(Date.now() - 86400000 * 5), dayCount(5)],
      [new Date(Date.now() - 86400000 * 4), dayCount(4)],
      [new Date(Date.now() - 86400000 * 3), dayCount(3)],
      [new Date(Date.now() - 86400000 * 2), dayCount(2)],
      [new Date(Date.now() - 86400000), dayCount(1)],
      [new Date(), days],
    ];

    <Chart
      chartType="AreaChart"
      maxWidth="100%"
      maxHeight="400px"
      data={data}
      options={options}
    />


    const Continue = (props) => {

      

      if ( props /*Could use '<' to make it choose all unlocked levels. */<= +localStorage.getItem("levelCount")){

        return (
          <div >
            <Button
                      variant="contained"
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1 }}
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #5208F0)'}}

                    >
                      {props === users.length - 1 ? 'Finish' : 'next level'}
                    </Button>
                    <Button
                      disabled={props === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                      variant="outlined"
                      style={{borderColor:'white', color: 'white'}}

                    >
                      Previous
                    </Button>
          </div>
        );

      } else {

        return (
          <div >
            <Button
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #5208F0)', color: 'white'}}
                      disabled
                    >
                      {props === users.length - 1 ? 'Finish' : 'Complete level to progress'}
                    </Button>
                    <Button
                      disabled={props === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1 }}
                      style={{borderColor:'white', color: 'white'}}
                      variant="outlined"
                    >
                      Previous
                    </Button>
          </div>
        );

    }

  }
  

  /*<OverlayTrigger trigger="click" placement="left" overlay={popover}>
          <img style={{maxHeight: '50px', padding: '1%'}} src={image}/> 
  </OverlayTrigger> */
    
  
  
  
  
  
  if (localStorage.getItem("language") === null || undefined) {

    return (
      <div>
      <div style={{backgroundColor: "#141332", padding: '13%', overflow: 'hidden'}}>
        <center>
          <h1 style={{backgroundColor: '#141332', color: 'white'}}>Please specify a language you're learning!</h1>
          <Link stlye={{textDecoration: 'none'}}to="/languages"><Button style={{backgroundImage: 'linear-gradient(to left, #ED4CDD, #5208F0)', color: "white", marginTop: '5%'}} size="lg">select</Button></Link>
        </center>
      </div>
      <Footer/>
      </div>
    );

  } else {
    
    return (
      <div style={{backgroundColor: "#141332", overflow: 'hidden'}}>
      <div style={{backgroundColor: "#141332", marginLeft: '5%', marginRight: '5%'}}>
      <Row>
            <Col sm={9}>
            <Link to="/"><ArrowBackIosIcon style={{marginTop: '3%', color: 'white'}}/></Link>
            </Col>
            <Col >
            <h3 style={{color: "white", marginTop: '16%', fontWeight: '900'}}>Lingo Loco</h3>
            </Col>
            <Col sm={1}>
              <OverlayTrigger trigger="hover" placement="bottom" overlay={popover}>
                <img src={image} style={{height: '50%', marginTop: '11%'}}/>
              </OverlayTrigger>
            </Col>
          </Row>
      
     <Row style={{marginBottom: '30px', marginTop: '-2%'}} data-aos="fade-up" data-aos-duration="1500">
       <Col sm={9} >
       <Box sx={{ maxWidth: 800 }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {users.map((step, index) => (
            <Step key={step.id}>
              <StepLabel >
              </StepLabel>
              <StepContent>
              <Card  style={{backgroundColor: "#1D1D41", color: 'white'}} >
                    <Card.Body >
                      <Row>
                      <Col >
                      <center>
                      <h2 style={{color: '', padding: '1%'}}>{step.id}</h2>
                      <h5 style={{color: '', padding: '1%'}}>{step.discription}</h5>
                      <h6 style={{color: 'grey', padding: '1%'}}>{step.topics}</h6>
                      </center>
                      </Col>
                      {loading ? <center><Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner></center> : <center><Link to="/questions" style={{textDecoration: 'none'}}><Button onClick={()=> pushLevel(step.id, index)} style={{ backgroundImage: 'linear-gradient(to left, #ED4CDD, #5208F0)', color: "white", border: 'none', width: '100%'}} size="lg">START</Button></Link></center> }
                      </Row>
                    </Card.Body>
              </Card>
                <Box sx={{ mb: 2 }}>
                  <div>
                    {Continue(index)}
                  </div>
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {activeStep === users.length && (
          <Paper square elevation={0} sx={{ p: 3 }}>
            <Typography>All steps completed - you&apos;re finished</Typography>
            <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
              Back To Start
            </Button>
          </Paper>
        )}
      </Box>
       </Col>
       <Col>
       <Card  style={{ height: '100%', backgroundColor: '#1D1D41'}} >
                    <Card.Body >
                    <div>
      <Accordion style={{backgroundImage: 'linear-gradient(to left, #ED4CDD, #5208F0)', color: 'white'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{color: 'white'}}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>RULES</Typography>
        </AccordionSummary>
        <AccordionDetails style={{backgroundColor: '#1D1D41', border: 'none'}}>
        <h5>Simple. Get to the end of the conversation!</h5><br/>
                <h6>1. This is a 'choose your own ending' conversation. each response results in a different routes the conversation leads.</h6><br/>
                <h6>2. The attempted response (1 of the three options) should be said out loud in the language you specified your learning.</h6><br/>
                <h6>3. You recieve 3 attempts per response, try all three or recieve specific hints if you attempt the same response more than once.</h6><br/>
                <h6>4. If the countdown bar hits 0 it reduces the ammount of attempts you get by 1.</h6><br/> 
        </AccordionDetails>
      </Accordion>
          </div>
          <br/>
          <Card style={{backgroundColor: '#141332', color: 'white'}}>
            <Card.Body>
            <h6>Get notified of new levels each week.</h6>
        <Form onSubmit={handleSubmit} >
            <Input style={{color:'white'}} sx={{':before': { borderBottomColor: 'white' },':after': { borderBottomColor: 'white' }}} type="email"  ref={emailRef}  placeholder="Enter your email" required/>
            <Button type="submit" >
              <ArrowForwardIosIcon style={{color: 'white'}}/>
            </Button>
          </Form>
          {AlertDismissable()}
            </Card.Body>
          </Card>
          <br/>
          <Card style={{backgroundColor: '#141332', color: 'white'}}>
      <Card.Body>
        <Card.Title><h6>Lessons</h6></Card.Title>
        <Card.Text>
          Check out our latest news and lessons with our articles.
        </Card.Text>
        <center><Link to="/lessons" style={{textDecoration: 'none'}}><Button style={{backgroundImage: 'linear-gradient(to left, #ED4CDD, #5208F0)', color: "white", border: 'none', width: '100%'}} size="lg">Read</Button></Link></center>      </Card.Body>
    </Card>
          <br/>
          <Card style={{backgroundColor: '#141332', color: 'white'}}>
            <Card.Body>
          <h6 >Daily Report</h6>
          <Chart
      chartType="AreaChart"
      maxWidth="100%"
      maxHeight="400px"
      data={data}
      options={options}
    />
    </Card.Body>
        </Card>

          
                    </Card.Body>
        </Card>
       
       </Col>
     </Row>
      </div>
      <Footer/>
      </div>
    );
  };


}

export default Levels;